// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"aOD3x":[function(require,module,exports,__globalThis) {
var _global = require("./global");
if (!customElements.get('product-modal')) customElements.define('product-modal', class ProductModal extends (0, _global.ModalDialog) {
    constructor(){
        super();
    }
    hide() {
        super.hide();
    }
    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }
    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element)=>{
            element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
    }
});

},{"./global":"aL7yG"}],"aL7yG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionId", ()=>SectionId);
parcelHelpers.export(exports, "HTMLUpdateUtility", ()=>HTMLUpdateUtility);
parcelHelpers.export(exports, "trapFocus", ()=>trapFocus);
parcelHelpers.export(exports, "pauseAllMedia", ()=>pauseAllMedia);
parcelHelpers.export(exports, "removeTrapFocus", ()=>removeTrapFocus);
parcelHelpers.export(exports, "onKeyUpEscape", ()=>onKeyUpEscape);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "throttle", ()=>throttle);
parcelHelpers.export(exports, "fetchConfig", ()=>fetchConfig);
parcelHelpers.export(exports, "ModalDialog", ()=>ModalDialog);
var _constants = require("./constants");
var _pubsub = require("./pubsub");
// import Swiper from 'swiper';
// import { Navigation, Controller, Thumbs, Autoplay } from 'swiper/modules';
var _swiperScss = require("../../node_modules/swiper/swiper.scss");
// Buy buttons product page sticky.
// document.addEventListener('DOMContentLoaded', () => {
//   const buyButton = document.querySelector('.product-sticky-button');
//   if (!buyButton) return;
//   const mqlTablet = window.matchMedia('(max-width: 749px)');
//   let scrollListenerAdded = false;
//   const handleScroll = () => {
//     requestAnimationFrame(() => {
//       const stickyOffsetBottom = buyButton.getBoundingClientRect().bottom + window.scrollY;
//       const threshold = window.scrollY + window.innerHeight;
//       if (threshold >= stickyOffsetBottom + 12) {
//         buyButton.classList.add('fixed-button');
//       } else if (threshold <= stickyOffsetBottom - buyButton.offsetHeight - 12) {
//         buyButton.classList.remove('fixed-button');
//       }
//     });
//   };
//   const handleResize = (e) => {
//     if (e.matches) {
//       buyButton.classList.add('sticky-button');
//       if (!scrollListenerAdded) {
//         window.addEventListener('scroll', handleScroll);
//         handleScroll();
//         scrollListenerAdded = true;
//       }
//     } else {
//       buyButton.classList.remove('sticky-button');
//       if (scrollListenerAdded) {
//         window.removeEventListener('scroll', handleScroll);
//         buyButton.classList.remove('fixed-button');
//         scrollListenerAdded = false;
//       }
//     }
//   };
//   mqlTablet.addEventListener('change', handleResize);
//   handleResize(mqlTablet);
// });
// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.mainSlider = this.querySelector('.product__slider');
//         this.mainSlider_slider = this.mainSlider.querySelector('.product__slider--slider');
//         this.sliderThumb = this.querySelector('.product__sliderThumb');
//         this.sliderThumb_slider = this.sliderThumb.querySelector('.product__sliderThumb--slider');
//         this.productMedias = this.querySelectorAll('.product__media');
//         this.isSwiperThumb = null;
//         this.isSwiperMain = null;
//         this.bp = window.matchMedia('screen and (min-width: 750px)');
//         this.bpTablet = window.matchMedia('screen and (min-width: 750px) and (max-width: 990px)');
//         this.bpDesktop = window.matchMedia('screen and (min-width: 991px)');
//         window.addEventListener('DOMContentLoaded', () => {
//           this.init();
//         });
//       }
//       init() {
//         this.initPages();
//         window.addEventListener('resize', () => {
//           clearTimeout(window.swiperResizeTimeout);
//           window.swiperResizeTimeout = setTimeout(() => {
//             this.initPages();
//           }, 200);
//         });
//       }
//       initPages() {
//         const direction = this.bpDesktop.matches ? 'vertical' : 'horizontal';
//         const spaceBetween = 0;
//         const sliderThumbHeight = (swiper) => {
//           const slidesPerView = swiper.params.slidesPerView;
//           const spaceBetween = swiper.params.spaceBetween;
//           const sliderProduct = this.mainSlider.offsetHeight;
//           let slideHeight = 0;
//           swiper.slides.forEach((slide) => {
//             const currentSlideHeight = slide.querySelector('.thumbnail').offsetHeight;
//             if (currentSlideHeight > slideHeight) {
//               slideHeight = currentSlideHeight;
//             }
//           });
//           const itemSlide = this.sliderThumb.querySelector('.product__sliderThumb__list__item .thumbnail').offsetHeight;
//           const itemSlideHeight = slideHeight + spaceBetween;
//           const nbrSlidePossible = Math.floor(sliderProduct / itemSlideHeight);
//           const extraSlides = slidesPerView - nbrSlidePossible;
//           let totalHeight = slidesPerView * itemSlideHeight;
//           if (nbrSlidePossible < slidesPerView) {
//             totalHeight = (nbrSlidePossible - extraSlides) * itemSlideHeight;
//             swiper.params.slidesPerView = extraSlides;
//           }
//           this.sliderThumb.style.maxHeight = 'max-content';
//           this.sliderThumb_slider.style.height = `${totalHeight}px`;
//         };
//         const sliderProduct = this.mainSlider.getBoundingClientRect().height;
//         if (!this.bpDesktop.matches && this.isSwiperThumb) {
//           this.isSwiperThumb.destroy(true, true);
//           this.isSwiperThumb = null;
//         }
//         if (!this.bpTablet.matches && this.isSwiperThumb) {
//           this.isSwiperThumb.destroy(true, true);
//           this.isSwiperThumb = null;
//         }
//         if (this.bp.matches && !this.isSwiperThumb) {
//           this.isSwiperThumb = new Swiper(this.sliderThumb_slider, {
//             modules: [Navigation, Controller, Thumbs],
//             spaceBetween: 10,
//             slidesPerView: 5,
//             watchOverflow: true,
//             grabCursor: true,
//             direction: direction,
//             centeredSlidesBounds: true,
//             watchSlidesVisibility: true,
//             watchSlidesProgress: true,
//             // slideToClickedSlide: true,
//             initialSlide: 0,
//             // loopAdditionalSlides: 2,
//             navigation: {
//               nextEl: this.sliderThumb.querySelector('.slider-button--next'),
//               prevEl: this.sliderThumb.querySelector('.slider-button--prev'),
//             },
//             breakpoints: {
//               460: {
//                 slidesPerView: 4,
//               },
//               991: {
//                 spaceBetween: 20,
//                 slidesPerView: 4,
//               },
//             },
//             on: {
//               init: (swiper) => {
//                 const slidesPerView = swiper.params.slidesPerView;
//                 if (swiper.params.slidesPerView == 'auto') return;
//                 if (this.bpDesktop.matches) {
//                   sliderThumbHeight(swiper);
//                 }
//               },
//             },
//           });
//         } else if (!this.bp.matches && this.isSwiperThumb) {
//           this.isSwiperThumb.destroy(true, true);
//           this.isSwiperThumb = null;
//         }
//         if (this.bp.matches && !this.isSwiperMain) {
//           this.isSwiperMain = new Swiper(this.mainSlider_slider, {
//             modules: [Navigation, Controller, Thumbs],
//             slidesPerView: 1,
//             // autoHeight: true,
//             loop: true,
//             initialSlide: 0,
//             watchOverflow: true,
//             watchSlidesVisibility: true,
//             watchSlidesProgress: true,
//             preventInteractionOnTransition: true,
//             grabCursor: true,
//             thumbs: {
//               swiper: this.isSwiperThumb,
//             },
//             navigation: {
//               nextEl: this.mainSlider.querySelector('.slider-button--next'),
//               prevEl: this.mainSlider.querySelector('.slider-button--prev'),
//             },
//             breakpoints: {
//               991: {
//                 autoHeight: false,
//               },
//             },
//           });
//         } else if (!this.bp.matches && this.isSwiperMain) {
//           this.isSwiperMain.destroy(true, true);
//           this.isSwiperMain = null;
//         }
//       }
//     }
//   );
// }
function getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
class SectionId {
    static #separator = '__';
    // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
    static parseId(qualifiedSectionId) {
        return qualifiedSectionId.split(SectionId.#separator)[0];
    }
    // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
    static parseSectionName(qualifiedSectionId) {
        return qualifiedSectionId.split(SectionId.#separator)[1];
    }
    // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
    static getIdForSection(sectionId, sectionName) {
        return `${sectionId}${SectionId.#separator}${sectionName}`;
    }
}
class HTMLUpdateUtility {
    /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */ static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        preProcessCallbacks?.forEach((callback)=>callback(newContent));
        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;
        // dedupe IDs
        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element)=>{
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });
        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';
        postProcessCallbacks?.forEach((callback)=>callback(newNode));
        setTimeout(()=>oldNode.remove(), 500);
    }
    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag)=>{
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute)=>{
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
}
// Main menu drawer.
const setupClickMenus = ()=>{
    document.querySelectorAll('[id^="Details-"] summary').forEach((summary)=>{
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
        if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
        summary.addEventListener('click', (event)=>{
            const details = event.currentTarget.closest('details');
            const isOpen = details.hasAttribute('open');
            event.currentTarget.setAttribute('aria-expanded', !isOpen);
        });
        if (summary.closest('header-drawer, menu-drawer')) return;
        summary.parentElement.addEventListener('keyup', onKeyUpEscape);
    });
};
// Main menu hover.
const setupHoverMenus = ()=>{
    document.querySelectorAll('.header__menu [id^="Details-"]').forEach((detail)=>{
        const summary = detail.querySelector('summary');
        detail.addEventListener('mouseenter', ()=>{
            detail.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
        });
        detail.addEventListener('mouseleave', ()=>{
            summary.setAttribute('aria-expanded', 'false');
            detail.removeAttribute('open');
        });
    });
};
// Fonction principale
const menuDropDown = ()=>{
    // Nettoyage des anciens écouteurs (optionnel mais recommandé pour éviter les doublons)
    document.querySelectorAll('[id^="Details-"]').forEach((detail)=>{
        const newDetail = detail.cloneNode(true);
        detail.replaceWith(newDetail);
    });
    const isDesktop = window.matchMedia('(min-width: 991px)').matches;
    if (isDesktop) setupHoverMenus();
    else setupClickMenus();
};
document.addEventListener('DOMContentLoaded', menuDropDown);
window.addEventListener('resize', menuDropDown);
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = (event)=>{
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    elementToFocus.focus();
    if (elementToFocus.tagName === 'INPUT' && [
        'search',
        'text',
        'email',
        'url'
    ].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN'
    ];
    let currentFocusedElement = null;
    let mouseClick = null;
    window.addEventListener('keydown', (event)=>{
        if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
    });
    window.addEventListener('mousedown', (event)=>{
        mouseClick = true;
    });
    window.addEventListener('focus', ()=>{
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
        if (mouseClick) return;
        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
    }, true);
}
function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video)=>{
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video)=>{
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video)=>video.pause());
    document.querySelectorAll('product-model').forEach((model)=>{
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}
window.pauseAllMedia = pauseAllMedia;
function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}
class QuantityInput extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: true
        });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button)=>button.addEventListener('click', this.onButtonClick.bind(this)));
    }
    quantityUpdateUnsubscriber = undefined;
    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = (0, _pubsub.subscribe)((0, _constants.PUB_SUB_EVENTS).quantityUpdate, this.validateQtyRules.bind(this));
    }
    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
    }
    onInputChange(event) {
        this.validateQtyRules();
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        if (event.target.name === 'plus') {
            if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) this.input.value = this.input.dataset.min;
            else this.input.stepUp();
        } else this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        if (this.input.dataset.min === previousValue && event.target.name === 'minus') this.input.value = parseInt(this.input.min);
    }
    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}
customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}
function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) return;
        lastCall = now;
        return fn(...args);
    };
}
function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: `application/${type}`
        }
    };
}
/*
 * Shopify Common JS
 *
 */ if (typeof window.Shopify == 'undefined') window.Shopify = {};
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};
Shopify.setSelectorByValue = function(selector, value) {
    for(var i = 0, count = selector.options.length; i < count; i++){
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);
    for(var key in params){
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },
    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) Shopify.setSelectorByValue(this.provinceEl, value);
    },
    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) this.provinceContainer.style.display = 'none';
        else {
            for(var i = 0; i < provinces.length; i++){
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }
            this.provinceContainer.style.display = '';
        }
    },
    clearOptions: function(selector) {
        while(selector.firstChild)selector.removeChild(selector.firstChild);
    },
    setOptions: function(selector, values) {
        for(var i = 0, count = values.length; i < values.length; i++){
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};
const menuDrawerShop = document.querySelector('#HeaderDrawer-shop');
if (menuDrawerShop) {
    menuDrawerShop.setAttribute('aria-expanded', true);
    menuDrawerShop.parentNode.setAttribute('open', true);
}
class TogglerMenuDrawer extends HTMLElement {
    constructor(){
        super();
        this.menuToToggle = document.querySelector(`#${this.getAttribute('toggle-menu')}`);
        if (this.menuToToggle) this.bindEvents();
        else console.error(`\xc9l\xe9ment non trouv\xe9 pour le s\xe9lecteur : ${this.getAttribute('toggle-menu')}`);
    }
    bindEvents() {
        this.addEventListener('click', this.toggleDrawer.bind(this));
    }
    toggleDrawer() {
        document.documentElement.classList.toggle('open-drawer');
    }
}
customElements.define('toggler-menu-drawer', TogglerMenuDrawer);
class ModalDialog extends HTMLElement {
    constructor(){
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event)=>{
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) this.addEventListener('pointerup', (event)=>{
            if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
        else this.addEventListener('click', (event)=>{
            if (event.target === this) this.hide();
        });
    }
    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
        document.body.appendChild(this);
    }
    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);
class ModalOpener extends HTMLElement {
    constructor(){
        super();
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', ()=>{
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    // this.init();
    }
}
customElements.define('modal-opener', ModalOpener);
class SwiperComponent extends HTMLElement {
    constructor(){
        super();
        this.slides = this.querySelectorAll('.swiper-slide');
        this.initSwiper();
    }
    getSlidesPerView(numberSlide) {
        const breakpoints = {
            mobile: 2,
            tablet: 3,
            smallDesktop: 4,
            desktop: 5
        };
        if (numberSlide > 2) breakpoints.mobile = 2.5;
        if (numberSlide > 3) breakpoints.tablet = 3.5;
        if (numberSlide > 4) breakpoints.smallDesktop = 4.5;
        if (numberSlide > 5) breakpoints.desktop = 5.5;
        return breakpoints;
    }
    initSwiper() {
        const numberSlide = this.slides.length;
        if (numberSlide <= 0) return;
        const { mobile, tablet, smallDesktop, desktop } = this.getSlidesPerView(numberSlide);
        new Swiper(this, {
            modules: [
                Navigation
            ],
            slidesPerView: 1.5,
            navigation: {
                nextEl: this.querySelector('.slider-next'),
                prevEl: this.querySelector('.slider-prev')
            },
            breakpoints: {
                550: {
                    slidesPerView: mobile
                },
                768: {
                    slidesPerView: tablet
                },
                970: {
                    slidesPerView: smallDesktop
                },
                1300: {
                    slidesPerView: desktop
                }
            }
        });
    }
}
customElements.define('swiper-component', SwiperComponent);
class AnnouncementBar extends HTMLElement {
    constructor(){
        super();
        this.autoPlay = this.getAttribute('data-autoplay');
        this.slides = this.querySelectorAll('.swiper-slide');
        // this.initSwiper();
        this.heightInCss();
        window.addEventListener('scroll', this.onScroll.bind(this), false);
    }
    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.offsetHeight) document.documentElement.classList.add('hide-announcement');
        else document.documentElement.classList.remove('hide-announcement');
    }
    heightInCss() {
        document.documentElement.style.setProperty('--announcement-height', `${this.offsetHeight}px`);
    }
    initSwiper() {
        const numberSlide = this.slides.length;
        if (numberSlide <= 1) return;
        new Swiper(this, {
            modules: [
                Navigation,
                Autoplay
            ],
            slidesPerView: 1,
            autoplay: this.autoPlay === 'true' ? {
                delay: 5000
            } : false,
            speed: 1000,
            loop: true,
            navigation: {
                nextEl: this.querySelector('.slider-button--next'),
                prevEl: this.querySelector('.slider-button--prev')
            }
        });
    }
}
customElements.define('announcement-bar', AnnouncementBar);
class VariantSelects extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.addEventListener('change', (event)=>{
            const target = this.getInputForEventTarget(event.target);
            this.updateSelectionMetadata(event);
            (0, _pubsub.publish)((0, _constants.PUB_SUB_EVENTS).optionValueSelectionChange, {
                data: {
                    event,
                    target,
                    selectedOptionValues: this.selectedOptionValues
                }
            });
        });
    }
    updateSelectionMetadata({ target }) {
        const { value, tagName } = target;
        if (tagName === 'SELECT' && target.selectedOptions.length) {
            Array.from(target.options).find((option)=>option.getAttribute('selected')).removeAttribute('selected');
            target.selectedOptions[0].setAttribute('selected', 'selected');
            const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
            const selectedDropdownSwatchValue = target.closest('.product-form__input').querySelector('[data-selected-value] > .swatch');
            if (!selectedDropdownSwatchValue) return;
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
            selectedDropdownSwatchValue.style.setProperty('--swatch-focal-point', target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset');
        } else if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }
    getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
    get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(({ dataset })=>dataset.optionValueId);
    }
}
customElements.define('variant-selects', VariantSelects);
class ProductRecommendations extends HTMLElement {
    observer = undefined;
    constructor(){
        super();
    }
    connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
    }
    initializeRecommendations(productId) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver((entries, observer)=>{
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations(productId);
        }, {
            rootMargin: '0px 0px 400px 0px'
        });
        this.observer.observe(this);
    }
    loadRecommendations(productId) {
        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`).then((response)=>response.text()).then((text)=>{
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations?.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
            if (!this.querySelector('announcement-bar') && this.classList.contains('complementary-products')) this.remove();
            if (html.querySelector('.grid__item')) this.classList.add('product-recommendations--loaded');
        }).catch((e)=>{
            console.error(e);
        });
    }
}
customElements.define('product-recommendations', ProductRecommendations);

},{"./constants":"k682v","./pubsub":"cylrF","../../node_modules/swiper/swiper.scss":"7Nzea","@parcel/transformer-js/src/esmodule-helpers.js":"dfqnz"}],"k682v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ON_CHANGE_DEBOUNCE_TIMER", ()=>ON_CHANGE_DEBOUNCE_TIMER);
parcelHelpers.export(exports, "PUB_SUB_EVENTS", ()=>PUB_SUB_EVENTS);
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dfqnz"}],"dfqnz":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"cylrF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribe", ()=>subscribe);
parcelHelpers.export(exports, "publish", ()=>publish);
let subscribers = {};
function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) subscribers[eventName] = [];
    subscribers[eventName] = [
        ...subscribers[eventName],
        callback
    ];
    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb)=>{
            return cb !== callback;
        });
    };
}
function publish(eventName, data) {
    if (subscribers[eventName]) subscribers[eventName].forEach((callback)=>{
        callback(data);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"dfqnz"}],"7Nzea":[function() {},{}]},["aOD3x"], "aOD3x", "parcelRequire7cb6", {})

//# sourceMappingURL=product-modal.js.map
